import { createStore } from 'redux';

const initialState = {
  currentLanguage: ''
};

function cabinetStore(state = initialState, action) {
  switch (action.type) {
    case 'SIGN_IN':
      return {
        ...state,
        account: action.payload
      };
    case 'SET_LOCALIZATION':
      return {
        ...state,
        currentLanguage: action.payload,
      };
    case 'LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state
  }
}

let store = createStore(cabinetStore);

// store.subscribe(() => console.log(store.getState()));

export default store;